// extracted by mini-css-extract-plugin
export var details = "_ha-0";
export var inspectorPopover = "_ha-1";